import { InputGroupData } from "../../../../interfaces/ui/InputGroupData"

export const FirstPartInputs: InputGroupData[] = [
  {
    name: 'demandingName',
    placeholder: 'Nombre',
    icon: "fa fa-user",
    required: true
  },
  {
    name: 'demandingFirstLastName',
    placeholder: 'Primer Apellido',
    icon: "fa fa-user",
    required: true
  },
  {
    name: 'demandingSecondLastName',
    placeholder: 'Segundo Apellido',
    icon: "fa fa-user",
    required: true
  },
  {
    name: 'demandingPhone',
    placeholder: 'Número Celular',
    icon: "fa fa-phone",
    required: true,
    maxChars: 10
  },
  {
    name: 'demandingEmail',
    placeholder: 'Correo Electrónico',
    icon: 'fa fa-envelope',
  },
  {
    name: "demandingCurp",
    placeholder: "CURP",
    icon: "fa fa-id-card",
    required: true,
    maxChars: 18
  }
]

export const SecondPartInputs: InputGroupData[] = [
  {
    name: 'defendantName',
    placeholder: 'Nombre',
    icon: 'fa fa-user',
    required: true
  },
  {
    name: 'defendantFirstLastName',
    placeholder: 'Primer Apellido(opcional)',
    icon: 'fa fa-user',
  },
  {
    name: 'defendantSecondLastName',
    placeholder: 'Segundo Apellido(opcional)',
    icon: 'fa fa-user',
  },
  {
    name: 'defendantPhone',
    placeholder: 'Número Celular(opcional)',
    icon: 'fa fa-phone',
  },
  {
    name: "defendantAddress",
    placeholder: "Domicilio Completo (calle, número, colonia, estado)",
    icon: "fa fa-map-marker",
    required: true
  }
]